var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6298 14.6598L21.2198 16.5198C20.5098 19.7198 17.9998 21.9998 14.3798 21.9998H9.61976C5.99975 21.9998 3.48974 19.7198 2.77974 16.5198L2.36974 14.6598C2.16974 13.7498 2.70974 12.7198 3.57974 12.3698L4.99975 11.7998L10.5098 9.58981C10.9898 9.3998 11.4998 9.2998 11.9998 9.2998C12.4998 9.2998 13.0098 9.3998 13.4898 9.58981L18.9998 11.7998L20.4198 12.3698C21.2898 12.7198 21.8298 13.7498 21.6298 14.6598Z",
    fill: "#0061AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.00002V9.44002C19 9.79002 18.64 10.04 18.31 9.90002L14.04 8.19001C12.7241 7.67825 11.2635 7.68182 9.95001 8.20002L5.69 9.91002C5.61426 9.9414 5.53196 9.95364 5.45037 9.94565C5.36878 9.93766 5.29042 9.90969 5.2222 9.86421C5.15399 9.81874 5.09803 9.75716 5.05928 9.68492C5.02052 9.61268 5.00016 9.532 5 9.45002V8.00002C5 6.35001 6.35 5.00001 8.00001 5.00001H16C17.65 5.00001 19 6.35001 19 8.00002ZM14.5 5.00001H9.50001V3C9.50001 2.45 9.95001 2 10.5 2H13.5C14.05 2 14.5 2.45 14.5 3V5.00001Z",
    fill: "#0061AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.60e1941807c738c3266fb1fd9a2f1a50.svg";
export { ForwardRef as ReactComponent };